import USER_ROLES from '../../constants/user-roles'
import { get } from 'lodash'

const isFacilitator = (user) => (get(user, 'rolesCode', '') || '').includes(USER_ROLES.FACILITATOR)

export default isFacilitator